import Beanie from "../assets/product_images/Menu_Beanie.svg";
import CasualSocks from "../assets/product_images/Menu_Casual_Socks.svg";
import Hoodie from "../assets/product_images/Menu_Hoodie.svg";
import HoodieSnap from "../assets/product_images/Menu_Hoodie_Snap.svg";
import HoodieJunior from "../assets/product_images/Menu_Hoodie_junior.svg";
import HoodieWoman from "../assets/product_images/Menu_Hoodie_women.svg";
import HoodieZip from "../assets/product_images/Menu_Hoodie_zip.svg";
import LongSleeve from "../assets/product_images/Menu_Longsleeve.svg";
import Mockneck from "../assets/product_images/Menu_Mockneck.svg";
import MockneckZip from "../assets/product_images/Menu_Mockneck_zip.svg";
import PolarVest from "../assets/product_images/Menu_Polar_Vest.svg";
import PoloM from "../assets/product_images/Menu_Polo_M.svg";
import PoloW from "../assets/product_images/Menu_Polo_W.svg";
import BeaniePompom from "../assets/product_images/Menu_Pompom_Beanie.svg";
import Pullover from "../assets/product_images/Menu_Pullover.svg";
import PulloverZip from "../assets/product_images/Menu_Pullover_Zip.svg";
import PulloverJunior from "../assets/product_images/Menu_Pullover_junior.svg";
import SleevelessVest from "../assets/product_images/Menu_Sleeveless.svg";
import SportSocks from "../assets/product_images/Menu_Sport_Socks.svg";
import SweatPants from "../assets/product_images/Menu_Sweatpants.svg";
import SweatShirt from "../assets/product_images/Menu_Sweatshirt.svg";
import TShirt from "../assets/product_images/Menu_T-shirt.svg";
import TShirtJunior from "../assets/product_images/Menu_T-shirt_junior.svg";
import WomanTShirt from "../assets/product_images/Menu_T-shirt_women.svg";
import BeanieWaffle from "../assets/product_images/Menu_Waffle_Beanie.svg";
import Sleevelees_Jacket_M from "../assets/product_images/Sleevelees_Jacket_M.svg";
import Sleevelees_Jacket_W from "../assets/product_images/Sleevelees_Jacket_W.svg";
import { MaterialSymbolType } from "../common/components/Icon/IconConstant";
import { palette } from "../styles/theme";
import {
  COUNTRY,
  Country,
  CURRENCY,
  Currency,
  Product,
  ProductFamily,
  ProductLineType,
} from "../types";

export const ROUTES = {
  TEAM: "/teams/:teamId",
  PROJECT: "/teams/:teamId/projects/:projectId",
  STUDIO: "/teams/:teamId/projects/:projectId/designs/:designId",
  LOGIN_WITH_TOKEN: "/login/:token",
  LOGIN: "/login",
  SIGN_UP: "/signup",
  SIGN_UP_WITH_TOKEN: "/signup/:token",
  RESET_PASSWORD: "/resetpassword",
  UPDATE_PASSWORD: "/resetpassword/:token",
  HOME: "/home",
  TEMPLATES: "/templates",
  CART: "/cart",
  ORDERS: "/orders",
  ORDER: "/orders/:orderId",
  ORDERS_SUCCESS: "/orders/success/:orderId",
  USER_PROFILE: "/profile",
  ADMIN: "/admin",
  ADMIN_ALL_ORDERS: "/admin/orders",
  ADMIN_DISTRIBUTORS: "/admin/distributors",
  ADMIN_TECHPACK_ORDER: "/admin/orders/:orderId/techpack/",
  ADMIN_ORDER: "/admin/orders/:orderId",
  ADMIN_STUDIO_PURCHASED_DESIGN:
    "/admin/orders/:orderType/:orderId/designs/:designId/from/:historyFrom",
  SIZES: "/projects/:projectId/collectsizes",
  COLLECT_SIZE: "/sizes/:token",
  COLLECT_SIZE_SUCCESS: "/sizes/success/:token",
  JOIN: "/join/:token",
  CHECKOUT: "/cart/checkout",
  ERROR: "/error",
};

export const EXTERNAL_ROUTE = {
  fr: {
    SUPPORT: "https://www.jameo.com/fr/faq",
    SUSTAINABILITY: "https://www.jameo.com/fr/developpement-durable",
    WORK_WITH_DESIGNER: "https://jameo.typeform.com/to/CKynHjov",
  },
  en: {
    SUPPORT: "https://www.jameo.com/faq",
    SUSTAINABILITY: "https://www.jameo.com/sustainability",
    WORK_WITH_DESIGNER: "https://jameo.typeform.com/to/xeI6m0mV",
  },
};

//UI stuff

export const MIN_CHAR_AUTO_COMPLETE = 3;
export const DELIVERY_PREP_DAYS_BUFFER = 4;
export const NON_SUPPORTED_BROWSER_FILE_EXTENSIONS = ["ai", "eps"];

/**
 * Artworks types (aligned with Specs artwork types)
 */
export const ARTWORK_TYPES = Object.freeze({
  TECHPACK_PRODUCTION: "techpackproduction",
});

export const DEFAULT_CURRENCY: Currency = CURRENCY.CAD;
export const CURRENCY_STORAGE_ITEM = "userCurrency";

export const DEFAULT_COUNTRY: Country = COUNTRY.CA;
export const COUNTRY_STORAGE_ITEM = "userCountry";

/**
 * Asset behaves like (aligned with Specs behavesLike)
 */
export enum BEHAVES_LIKE {
  DETAILED_PRINT_TYPE = "detailedPrintType",
  EMBROIDERY_PATCH_TYPE = "embroideryPatchType",
  LEATHER_TAG_TYPE = "leatherTagType",
  SCREENPRINT_TYPE = "screenprintType",
  WOVEN_TAG_TYPE = "wovenTagType",
  CUSTOM_LABEL_TYPE = "customLabelType",
}

export enum ONBOARDING_STEPS {
  EMAIL = "email",
  LOGIN = "login",
  SIGNUP = "signup",
  ABOUT_PROJECT = "about",
}

export enum ABOUT_PROJECT_STEPS {
  PROJEC_TYPE = "projectType",
  CONTACT_PHONE = "contactPhone",
  TEAM_NAME = "teamName",
  PROJECT_SIZE = "projectSize",
}

export enum PROJECT_SIZES {
  LESS_20 = "0-19",
  LESS_50 = "20-49",
  LESS_150 = "50-149",
  LESS_500 = "150-499",
  LESS_5000 = "500-4999",
  MORE_5000 = "5000-",
}

//About Project, for who
export enum PROJECT_TYPES {
  COMPANY = "company",
  STUDENT = "student",
  PERSONAL = "personal",
  DISTRIBUTOR = "distributor",
  SOUVENIR_SHOP = "souvenirShop",
  OTHER = "other",
}

export enum HISTORY_EVENT {
  CREATED = "created",
  UPDATE_SIZE = "size_updated",
  ITEM_ADDED = "item_added",
  ITEM_REMOVED = "item_removed",
  STATUS_UPDATE = "status_updated",
  INVOICE_UPDATE = "invoice_updated",
  CURRENCY_UPDATED = "currency_updated",
  SHIPPING_UPDATED = "shipping_updated",
  BILLING_UPDATED = "billing_updated",
  PURCHASED_DESIGN_UPDATED = "purchased_design_updated",
  PO_NUMBER_UPDATED = "po_number_updated",
  CARBON_NEUTRAL_UPDATED = "carbon_neutral_updated",
  CLIENT_DETAILS_UPDATED = "client_details_updated",
  UPDATE_PROJECT_NUMBER = "project_number_updated",
}

//NOTE - Temporary, so that in prod we only see the products that are "approved"
// const comingSoon = process.env.REACT_APP_ENV !== "dev";

//if we cant change the family value of some product, ill have to group them by a groupId or something along those lines

export const ProductList: Product[] = [
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "tshirt", version: "1.0" },
    labelTag: "tshirt.name",
    imgName: TShirt,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "tshirtEco", version: "1.0" },
    labelTag: "tshirt.name",
    imgName: TShirt,
    minQty: 30,
    line: ProductLineType.ECO,
    adminOnly: true,
  },
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "tshirtClassic", version: "1.0" },
    labelTag: "tshirt.name",
    imgName: TShirt,
    minQty: 30,
    line: ProductLineType.CLASSIC,
    adminOnly: true,
  },
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "womanTshirt", version: "1.0" },
    labelTag: "womanTshirt.name",
    imgName: WomanTShirt,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/femmes",
      en: "https://www.jameo.com/sizes/women",
    },
  },
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "tshirtJunior", version: "1.0" },
    labelTag: "tshirtJunior.name",
    imgName: TShirtJunior,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-junior",
      en: "https://www.jameo.com/sizes/unisex-junior",
    },
  },
  {
    family: { name: "longsleeve", version: "1.0" },
    product: { name: "longsleeve", version: "1.0" },
    labelTag: "longsleeve.name",
    imgName: LongSleeve,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "longsleeve", version: "1.0" },
    product: { name: "longsleeveEco", version: "1.0" },
    labelTag: "longsleeve.name",
    imgName: LongSleeve,
    minQty: 30,
    line: ProductLineType.ECO,
    adminOnly: true,
  },
  {
    family: { name: "longsleeve", version: "1.0" },
    product: { name: "longsleeveClassic", version: "1.0" },
    labelTag: "longsleeve.name",
    imgName: LongSleeve,
    minQty: 30,
    line: ProductLineType.CLASSIC,
    adminOnly: true,
  },
  {
    family: { name: "polo", version: "1.0" },
    product: { name: "poloMen", version: "1.0" },
    labelTag: "poloMen.name",
    imgName: PoloM,
    minQty: 50,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/hommes",
      en: "https://www.jameo.com/sizes/men",
    },
  },
  {
    family: { name: "polo", version: "1.0" },
    product: { name: "poloWomen", version: "1.0" },
    labelTag: "poloWomen.name",
    imgName: PoloW,
    minQty: 50,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/femmes",
      en: "https://www.jameo.com/sizes/women",
    },
  },
  {
    family: { name: "sweatshirt", version: "1.0" },
    product: { name: "sweatshirt", version: "1.0" },
    labelTag: "sweatshirt.name",
    imgName: SweatShirt,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "sweatshirt", version: "1.0" },
    product: { name: "sweatshirtEco", version: "1.0" },
    labelTag: "sweatshirt.name",
    imgName: SweatShirt,
    minQty: 30,
    line: ProductLineType.ECO,
    adminOnly: true,
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodie", version: "1.0" },
    labelTag: "hoodie.name",
    imgName: Hoodie,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieEco", version: "1.0" },
    labelTag: "hoodie.name",
    imgName: Hoodie,
    minQty: 30,
    line: ProductLineType.ECO,
    adminOnly: true,
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieClassic", version: "1.0" },
    labelTag: "hoodie.name",
    imgName: Hoodie,
    minQty: 30,
    line: ProductLineType.CLASSIC,
    adminOnly: true,
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieZip", version: "1.0" },
    labelTag: "hoodieZip.name",
    imgName: HoodieZip,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieWoman", version: "1.0" },
    labelTag: "hoodieWoman.name",
    imgName: HoodieWoman,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/femmes",
      en: "https://www.jameo.com/sizes/women",
    },
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieSnap", version: "1.0" },
    labelTag: "hoodieSnap.name",
    imgName: HoodieSnap,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieJunior", version: "1.0" },
    labelTag: "hoodieJunior.name",
    imgName: HoodieJunior,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-junior",
      en: "https://www.jameo.com/sizes/unisex-junior",
    },
  },
  {
    family: { name: "polar", version: "1.0" }, ///FIXME - Wait on backend to release this
    product: { name: "pulloverSnap", version: "2.0" },
    labelTag: "pulloverSnap.name",
    imgName: Pullover,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "polar", version: "1.0" }, ///FIXME - Wait on backend to release this
    product: { name: "pulloverJunior", version: "2.0" },
    labelTag: "pulloverJunior.name",
    imgName: PulloverJunior,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-junior",
      en: "https://www.jameo.com/sizes/unisex-junior",
    },
  },
  {
    family: { name: "polar", version: "1.0" }, ///FIXME - Wait on backend to release this
    product: { name: "pulloverZip", version: "2.0" },
    labelTag: "pulloverZip.name",
    imgName: PulloverZip,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "polar", version: "1.0" }, ///FIXME - Wait on backend to release this
    product: { name: "pulloverFullSnap", version: "1.0" },
    labelTag: "pulloverFullSnap.name",
    imgName: PolarVest,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
    adminOnly: true,
    deprecated: true,
  },
  {
    family: { name: "polar", version: "1.0" },
    product: { name: "sleevelessPolar", version: "2.0" },
    labelTag: "sleevelessPolar.name",
    imgName: SleevelessVest,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "mockneck", version: "1.0" },
    product: { name: "mockneck", version: "1.0" },
    labelTag: "mockneck.name",
    imgName: Mockneck,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "mockneck", version: "1.0" },
    product: { name: "mockneckFullZip", version: "1.0" },
    labelTag: "mockneckFullZip.name",
    imgName: MockneckZip,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "sleevelessJacket", version: "1.0" },
    product: { name: "sleevelessJacketMen", version: "1.0" },
    labelTag: "sleevelessJacketMen.name",
    imgName: Sleevelees_Jacket_M,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/hommes",
      en: "https://www.jameo.com/sizes/men",
    },
  },
  {
    family: { name: "sleevelessJacket", version: "1.0" },
    product: { name: "sleevelessJacketWoman", version: "1.0" },
    labelTag: "sleevelessJacketWoman.name",
    imgName: Sleevelees_Jacket_W,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/femmes",
      en: "https://www.jameo.com/sizes/women",
    },
  },
  {
    family: { name: "sweatpants", version: "1.0" },
    product: { name: "sweatpants", version: "1.0" },
    labelTag: "sweatpants.name",
    imgName: SweatPants,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/unisexe-hyper",
      en: "https://www.jameo.com/sizes/unisex-hyper",
    },
  },
  {
    family: { name: "beanie", version: "1.0" },
    product: { name: "beanie", version: "1.0" },
    labelTag: "beanie.name",
    imgName: Beanie,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
  },
  {
    family: { name: "beanie", version: "1.0" },
    product: { name: "waffleBeanie", version: "1.0" },
    labelTag: "waffleBeanie.name",
    imgName: BeanieWaffle,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
  },
  {
    family: { name: "beanie", version: "1.0" },
    product: { name: "pompomBeanie", version: "1.0" },
    labelTag: "pompomBeanie.name",
    imgName: BeaniePompom,
    minQty: 20,
    line: ProductLineType.HYPER_CUSTOM,
  },
  {
    family: { name: "socks", version: "1.0" },
    product: { name: "casualSocks", version: "1.0" },
    labelTag: "casualSocks.name",
    imgName: CasualSocks,
    minQty: 50,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/accessoires",
      en: "https://www.jameo.com/sizes/accessories",
    },
  },
  {
    family: { name: "socks", version: "1.0" },
    product: { name: "sportSocks", version: "1.0" },
    labelTag: "sportSocks.name",
    imgName: SportSocks,
    minQty: 50,
    line: ProductLineType.HYPER_CUSTOM,
    sizeChartUrl: {
      fr: "https://www.jameo.com/fr/grandeurs/accessoires",
      en: "https://www.jameo.com/sizes/accessories",
    },
  },
  // {
  //   family: { name: "mask", version: "1.0" },
  //   product: { name: "mask", version: "1.0" },
  //   labelTag: "mask.name",
  //   imgName: Mask,
  //   minQty: 50,
  //   comingSoon: comingSoon, //Remove when production has approved this product
  // },
];

export const ProductFamilyList: ProductFamily[] = [
  {
    id: "shirt",
    labelTag: "family.shirt",
    imgName: TShirt,
    lines: [
      { line: ProductLineType.HYPER_CUSTOM },
      { line: ProductLineType.ECO, adminOnly: true },
      { line: ProductLineType.CLASSIC, adminOnly: true },
    ],
  },
  {
    id: "longsleeve",
    labelTag: "family.longsleeves",
    imgName: LongSleeve,
    lines: [
      { line: ProductLineType.HYPER_CUSTOM },
      { line: ProductLineType.ECO, adminOnly: true },
      { line: ProductLineType.CLASSIC, adminOnly: true },
    ],
  },
  {
    id: "polo",
    labelTag: "family.polos",
    imgName: PoloM,
    lines: [{ line: ProductLineType.HYPER_CUSTOM }],
  },
  {
    id: "hoodie",
    labelTag: "family.hoodies",
    imgName: Hoodie,
    lines: [
      { line: ProductLineType.HYPER_CUSTOM },
      { line: ProductLineType.ECO, adminOnly: true },
      { line: ProductLineType.CLASSIC, adminOnly: true },
    ],
  },
  {
    id: "sweatshirt",
    labelTag: "family.sweatshirts",
    imgName: SweatShirt,
    lines: [
      { line: ProductLineType.HYPER_CUSTOM },
      { line: ProductLineType.ECO, adminOnly: true },
    ],
  },
  {
    id: "mockneck",
    labelTag: "family.mocknecks",
    imgName: Mockneck,
    lines: [{ line: ProductLineType.HYPER_CUSTOM }],
  },
  {
    id: "polar",
    labelTag: "family.polars",
    imgName: Pullover,
    lines: [{ line: ProductLineType.HYPER_CUSTOM }],
  },
  {
    id: "sleevelessJacket",
    labelTag: "family.sleevelessJackets",
    imgName: Sleevelees_Jacket_M,
    lines: [{ line: ProductLineType.HYPER_CUSTOM }],
  },
  {
    id: "sweatpants",
    labelTag: "family.sweatpants",
    imgName: SweatPants,
    lines: [{ line: ProductLineType.HYPER_CUSTOM }],
  },
  {
    id: "beanie",
    labelTag: "family.beanies",
    imgName: Beanie,
    lines: [{ line: ProductLineType.HYPER_CUSTOM }],
  },
  {
    id: "socks",
    labelTag: "family.socks",
    imgName: CasualSocks,
    lines: [{ line: ProductLineType.HYPER_CUSTOM }],
  },
];

export const ProductLinesToIcon: Record<ProductLineType, MaterialSymbolType> = {
  [ProductLineType.HYPER_CUSTOM]: "content_cut",
  [ProductLineType.ECO]: "psychiatry",
  [ProductLineType.CLASSIC]: "anchor",
};

export const ProductLinesToColor: Record<ProductLineType, string> = {
  [ProductLineType.HYPER_CUSTOM]: palette.blue.primary,
  [ProductLineType.ECO]: palette.misc.successText,
  [ProductLineType.CLASSIC]: palette.grey.nearBlack,
};

export const extraSizeList = ["2XL", "3XL", "4XL", "5XL"];
